import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

export default Backbone.View.extend({
  initialize() {
    Rover.pubSub.on('search:end', _.bind(this.onSearchEnd, this));
  },

  onSearchEnd() {
    const cityService = Rover.searchResults.get('city_service');

    if (cityService) {
      this.$el.find('h1').text(cityService.h1);
      this.$el.find('h2 > small').text(cityService.h2);
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/city_search_header_view.js